import { render } from "./LabRelease1View.vue?vue&type=template&id=5502c2b2"
import script from "./LabRelease1View.vue?vue&type=script&lang=js"
export * from "./LabRelease1View.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__